import React, { useEffect } from "react";
import Page from "../../../components/Page";
import LearnMCSessionPage from "./LearnMCSessionPage";
import { getActiveHeader } from "../../../redux/home/actions";
import { useDispatch } from "react-redux";

const NewLearnMCSessionPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getActiveHeader("events-list"));
  }, []);
  return (
    <Page>
      <div className="bannersection">
        <div className="container mt-5">
          <LearnMCSessionPage isEvents={true} />
        </div>
      </div>
    </Page>
  );
};

export default NewLearnMCSessionPage;
